import { Col, Row } from 'reactstrap';
import React, { useEffect, useMemo } from 'react';
import forms from 'constants/forms';
import Select from 'react-select';
import common from 'constants/common';
import { useDispatch, useSelector } from 'react-redux';
import { isAdmin, isAgencyDoctor } from 'utils/userTypeHelper';
import useUser from 'utils/useUser';
import Pagination from 'components/molecules/pagination';
import AutoCompleteClinics from 'components/molecules/autocompleteFilter/adminPanelClinic';
import AutoCompleteAgency from 'components/molecules/autocompleteFilter/adminPanelAgency';
import { isMobile } from 'utils/deviceHelper';

const Toolbar = () => {
  const { userType } = useUser();
  const DEFAULT_CLINIC_FILTER = forms.clinicFilterOptions[0];
  const statusFilterOptions = forms.clinicStatusFilterSelect;
  const selectTheme = (theme) => ({
    ...theme,
    borderRadius: 12,
    colors: {
      ...theme.colors,
      ...common.primaryColors,
    },
  });
  const adminPanelClinics = useSelector((state) => state.adminPanelClinics);
  const device = useSelector((state) => state.user.deviceType);
  const statusValue = useMemo(
    () =>
      statusFilterOptions.find(
        ({ value }) => adminPanelClinics?.filters?.status === value,
      ) || statusFilterOptions[0],
  );
  const { page, data, itemsPerPage, totalCount } = useSelector(
    (state) => state.adminPanelClinics,
  );
  const { getClinics: patientsLoading } = useSelector(
    (state) => state.loading.effects.adminPanelClinics,
  );
  const {
    adminPanelClinics: { setFilters, setClinicsPage, resetStatus },
  } = useDispatch();
  const setPage = (pageOffset) => {
    setClinicsPage({ pageOffset });
  };
  const clinicsFilter = DEFAULT_CLINIC_FILTER;
  useEffect(
    () => () => {
      resetStatus();
    },
    [],
  );

  return (
    <Row>
      <Col column="1">
        <strong>Clinic</strong>
        <AutoCompleteClinics
          filter={clinicsFilter}
          handleClick={({ value }) => {
            setFilters({ guid: value });
          }}
        />
      </Col>
      <Col column="2">
        <strong>Status</strong>
        <Select
          options={statusFilterOptions}
          defaultValue={statusFilterOptions[0]}
          theme={(theme) => selectTheme(theme)}
          classNamePrefix="select-type"
          value={statusValue}
          onChange={({ value }) => {
            setFilters({ status: value });
          }}
        />
      </Col>
      {(isAdmin(userType) || isAgencyDoctor(userType)) && (
        <Col column="2">
          <strong>Agency</strong>
          <AutoCompleteAgency
            filter={clinicsFilter}
            handleClick={({ value }) => {
              setFilters({ agencyGuid: value });
            }}
          />
        </Col>
      )}
      {!isMobile(device) && <Col column="5" />}
      <Col column="2">
        <Pagination
          title=""
          page={page}
          pageTotal={data?.length}
          itemsPerPage={itemsPerPage}
          total={totalCount}
          handleFirstClick={() => setPage(-(page - 1))}
          handleLastClick={() => setPage(Math.ceil(totalCount / itemsPerPage))}
          handlePrevClick={() => setPage(-1)}
          handleNextClick={() => setPage(+1)}
          loading={patientsLoading}
        />
      </Col>
    </Row>
  );
};

export default Toolbar;
